import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import CustomerSelectInput from '../../../../../inputs/customerSelectInput/CustomerSelectInput';
import useTranslation from '../../../../../../hooks/translation/useTranslation';
import { ReactComponent as Departure } from '../../../../../../../resources/images/svg/departure.svg';
import { ReactComponent as Location } from '../../../../../../../resources/images/svg/location.svg';
import { ReactComponent as SwitchIcon } from '../../../../../../../resources/images/svg/searchSwitch.svg';
import CustomerDatePicker from '../../../../../inputs/customerDatePicker/CustomerDatePicker';
import CustomerPassengersInput from '../../../../../inputs/customerPassengersInput/CustomerPassengersInput';
import { useAuth } from '../../../../../../contexts/userContext/userContext';
import SuggestedStations from './SuggestedStations';

function RidesSearchForm({
  form, handleSubmit, inputsClassName, style, errors, handleAfterSwitch = () => {},
}) {
  const {
    ticketBookingOptions: options,
  } = useAuth();

  const [stations, setStations] = useState([]);
  const { trans, currentLanguage } = useTranslation();

  const [isSwapped, setIsSwapped] = useState(false);

  const departureDateFrom = Form.useWatch('departureDateFrom', form);
  const returnDateFrom = Form.useWatch('returnDateFrom', form);

  const handleSwitch = () => {
    const startStation = form.getFieldValue('startStationCode');
    const endStation = form.getFieldValue('endStationCode');
    form.setFieldValue('startStationCode', endStation);
    form.setFieldValue('endStationCode', startStation);
    setIsSwapped(!isSwapped);
    handleAfterSwitch();
  };

  useEffect(() => {
    setStations(() => options
      ?.stations
      ?.filter((station) => station?.[`label_${currentLanguage}`] || station?.label_ka)
      ?.map((station) => (
        {
          id: station.id,
          label: station?.[`label_${currentLanguage}`] || station?.label_ka,
          value: station.value,
        }
      )));
  }, [options?.stations?.length, currentLanguage]);

  return (
    <Form
      form={form}
      className="flex gap-4 flex-col lg:flex-row"
      style={style}
      onFinish={handleSubmit}
    >
      <div className="flex flex-col lg:flex-row gap-4 relative flex-[3] min-w-0 justify-around">
        <div className="flex flex-col gap-2 flex-1">
          <CustomerSelectInput
            additionalClassName="custom-select-input"
            prefix={<Departure className="gray-svg-path" />}
            options={stations}
            className={`overflow-hidden ${inputsClassName}`}
            noError
            name="startStationCode"
            innerLabel={(
              <div className="truncate lg:max-w-[120px] xl:max-w-fit">
                {trans('from_where')}
              </div>
              )}
            errorMessage={errors?.startStationCode}
          />
          <SuggestedStations
            handleSubmit={(v) => {
              form.setFieldValue('startStationCode', v);
            }}
            direction="departure"
          />
        </div>
        <SwitchIcon
          onClick={handleSwitch}
          className={`z-10 absolute top-1/2 right-0 lg:left-1/2 transform -translate-y-1/2 -translate-x-1/2 rotate-90 lg:rotate-0 cursor-pointer h-7 w-7 ${isSwapped ? 'swapped' : ''}`}
        />
        <div className="flex flex-col gap-2  flex-1">
          <CustomerSelectInput
            additionalClassName="custom-select-input"
            prefix={<Location className="gray-svg-path" />}
            className={`overflow-hidden ${inputsClassName}`}
            options={stations}
            noError
            name="endStationCode"
            innerLabel={(
              <div className="truncate lg:max-w-[120px] xl:max-w-fit">
                {trans('where')}
              </div>
              )}
            errorMessage={errors?.endStationCode}
          />
          <SuggestedStations
            handleSubmit={(v) => {
              form.setFieldValue('endStationCode', v);
            }}
            direction="arrival"
          />
        </div>
      </div>
      <div className={`flex items-center justify-center gap-2 min-h-[60px] max-h-[60px] bg-gray-light-gr rounded-lg flex-[2] border border-transparent border-solid ${inputsClassName} ${(errors?.departureDateFrom || errors?.returnDateFrom) && 'border-red-gr'}`}>
        <CustomerDatePicker
          name="departureDateFrom"
          errorMessage={errors?.departureDateFrom}
          className={`flex-[1] flex justify-center ${inputsClassName}`}
          defaultValue={new Date()}
          noError
          maxDate={returnDateFrom}
          form={form}
        />
        <div className="h-[39px] bg-black w-[1px]" />
        <CustomerDatePicker
          name="returnDateFrom"
          errorMessage={errors?.returnDateFrom}
          className={`flex-[1] flex justify-center ${inputsClassName}`}
          defaultLabel={trans('back-road')}
          noError
          form={form}
          minDate={departureDateFrom}
          clear
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4 relative lg:flex-[3]">
        <CustomerPassengersInput errorMessage={errors?.standard_passengers} className={`min-h-[60px] ${inputsClassName}`} form={form} />
        <button
          type="submit"
          className="bg-primary min-h-[60px] max-h-[60px] border-0 text-white rounded-lg text-base cursor-pointer flex-1"
        >
          {trans('search')}
        </button>
      </div>

    </Form>
  );
}

export default RidesSearchForm;
